module.exports = __webpack_public_path__ + "img/tiktok.7c327e79.png";